import { Stack } from '@all-manager/design-system-v2';
import HistoryDrawer from "../HistoryDrawer/HistoryDrawer";
import PendingItemsSection from "../PendingItemsSection/PendingItemsSection";
import TodoSection from "../TodoSection/TodoSection";
import OngoingIncidentSection from "./OngoingIncidentSection/OngoingIncidentSection";
import RecentActivitiesSection from "./RecentActivitiesSection";
import UpcomingEventsSection from "./UpcomingEventsSection";
import { useActivitiesTab } from "./useActivitiesTab";

type Props = {
  subTopicId: string;
  onNavigateToIncidents?: () => void;
  onNavigateToJournal?: () => void;
};

export default function ActivitiesTab(props: Props) {
  const {
    recentActivities,
    totalActivitiesCount,
    activitiesLoading,
    events,
    eventsLoading,
    ongoingIncidents,
    handleSeeMore,
    historyDrawer,
  } = useActivitiesTab(props);

  return (
    <Stack spacing={3}>
      {ongoingIncidents.length > 0 ? (
        <OngoingIncidentSection
          incidents={ongoingIncidents}
          onNavigateToIncidents={props.onNavigateToIncidents}
        />
      ) : null}

      <RecentActivitiesSection
        items={recentActivities}
        isLoading={activitiesLoading}
        totalCount={totalActivitiesCount}
        onSeeMore={handleSeeMore}
      />

      <UpcomingEventsSection
        events={events}
        isLoading={eventsLoading}
      />

      <TodoSection subTopicId={props.subTopicId} />

      <PendingItemsSection subTopicId={props.subTopicId} />

      <HistoryDrawer
        isOpen={historyDrawer.isOpen}
        onClose={historyDrawer.handleClose}
        subTopicId={props.subTopicId}
      />
    </Stack>
  );
}

